import { z } from 'zod';

import { NOTIFICATION_TYPES } from '../enums';
import { zId, zOptionalString, zPagination } from './common';

/* ─── Настройки уведомлений ─────────────────────────────────────────────── */

export const notificationSettingsSchema = z.object({
  channelInApp: z.boolean().optional(),
  channelTelegram: z.boolean().optional(),

  dailyDigestEnabled: z.boolean().optional(),
  dailyDigestTime: z
    .string()
    .regex(/^\d{2}:\d{2}$/, { message: 'validation.invalidTime' })
    .optional(),

  /** Типы, которые пользователь не хочет получать. */
  mutedTypes: z.array(z.enum(NOTIFICATION_TYPES)).max(20).optional(),

  /** За сколько дней предупреждать. По умолчанию 7, 3 и 1. */
  reminderDaysBefore: z.array(z.number().int().min(0).max(90)).max(6).optional(),
  /** Как часто напоминать о просроченном. */
  overdueEveryDays: z.number().int().min(1).max(30).optional(),

  quietHoursFrom: zOptionalString(5),
  quietHoursTo: zOptionalString(5),
});
export type NotificationSettingsInput = z.infer<typeof notificationSettingsSchema>;

export const notificationFilterSchema = zPagination.extend({
  unreadOnly: z.coerce.boolean().default(false),
  type: z.enum(NOTIFICATION_TYPES).optional(),
});
export type NotificationFilter = z.infer<typeof notificationFilterSchema>;

export const markReadSchema = z.object({
  ids: z.array(zId).max(200).optional(),
  /** Пометить все прочитанными. */
  all: z.boolean().default(false),
});

/* ─── Ответы ────────────────────────────────────────────────────────────── */

export interface NotificationDto {
  id: string;
  type: string;
  title: string;
  body: string;
  severity: 'INFO' | 'WARN' | 'DANGER';
  entityType: string | null;
  entityId: string | null;
  dueDate: string | null;
  isRead: boolean;
  createdAt: string;
  workspaceId: string | null;
  workspaceName: string | null;
}

export interface NotificationListResponse {
  items: NotificationDto[];
  total: number;
  page: number;
  pageSize: number;
  pageCount: number;
  unreadCount: number;
}

export interface NotificationSettingsDto {
  channelInApp: boolean;
  channelTelegram: boolean;
  telegramLinked: boolean;
  /** Настроен ли Telegram на уровне платформы — иначе канал недоступен. */
  telegramAvailable: boolean;
  dailyDigestEnabled: boolean;
  dailyDigestTime: string;
  mutedTypes: string[];
  reminderDaysBefore: number[];
  overdueEveryDays: number;
  quietHoursFrom: string | null;
  quietHoursTo: string | null;
}

/** Результат прогона напоминаний — показывается в админке. */
export interface ReminderRunResult {
  runDate: string;
  created: number;
  skipped: number;
  workspaces: number;
  durationMs: number;
  byType: Record<string, number>;
}
